export const urls = {
  GET_DOBIT: 'DokRNServisni/dok_rn_servisni_pregled_dobiti',
};
